
import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { ActivatedRoute, Params } from '@angular/router'

@Component({
    template: ` <router-outlet></router-outlet>`,
    styleUrls: ['./EApp-beneficiary.component.scss']

})

export class EAppBeneficiaryComponent implements OnInit {
    uniqueLink: string
    constructor(private router: Router, private route: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.getParams();
        if (this.uniqueLink !== undefined && this.uniqueLink !== '') {
            this.router.navigateByUrl('/verify/' + this.uniqueLink)
        }
    }


    getParams() {
        this.route.params.forEach((params: Params) => {
            this.uniqueLink = this.route.snapshot.params["{guid}"]
        })
    }
}